import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import IconSpanContainer from './IconSpanContainer'

export default function Icon({ isDisabled, color, ...props }) {
  const disabledColor = isDisabled ? 'grey' : color;
  return (
    <IconSpanContainer>
      <FontAwesomeIcon
        { ...props }
        color={disabledColor}
      />
    </IconSpanContainer>
  );
}
